const identity_ = require('lodash/identity')
const merge_ = require('lodash/merge')
const pull_ = require('lodash/pull')
const mapValues_ = require('lodash/mapValues')
const omit_ = require('lodash/omit')
const has_ = require('lodash/has')

const retry = (Raven, ravenFunction) => (...args) => {
  try {
    Raven[ravenFunction](...args)
  } catch (e) {
    try {
      Raven[ravenFunction](
        `Failed on ${ravenFunction}. Got exception: ${e.name} - ${e.message}`,
        {
          extra: {
            'original-error': JSON.stringify(args)
          }
        }
      )
    } catch (e) {
      // well... we really have nothing to do here :(
    }
  }
}

const removeRecordsIfExists = value =>
  has_(value, 'state.records') ? omit_(value, 'state.records') : value

const removeUserData = data => mapValues_(data, removeRecordsIfExists)

module.exports = Raven => {
  const callbacks = []

  Raven.setDataCallback((data, originalCallback = identity_) => {
    callbacks.forEach(cb => merge_(data.extra, cb()))
    const finalData = originalCallback(data)
    finalData.extra = removeUserData(finalData.extra)

    return finalData
  })

  return {
    addDataCallback: cb => {
      callbacks.push(cb)
      return () => pull_(callbacks, cb)
    },
    captureBreadcrumb: (...args) => Raven.captureBreadcrumb(...args),
    captureException: (...args) => retry(Raven, 'captureException')(...args),
    captureMessage: (...args) => retry(Raven, 'captureMessage')(...args)
  }
}



// WEBPACK FOOTER //
// ./raven/ravenProxy.js